// extracted by mini-css-extract-plugin
export default {"whatWeDo":"BrowseVideo_whatWeDo__BHZf6","title":"BrowseVideo_title__CfQQp","options":"BrowseVideo_options__cZCMM","btn":"BrowseVideo_btn__3V+jR","icon":"BrowseVideo_icon__55NFC"};